import { h } from 'preact';
// import Store from 'store/store';
import * as categories from '../categories';
import * as tealiumCategories from './categories';
import * as queue from '../queue';
import { accessNested } from 'utils/utils';
import { dispatchEvent } from '../dispatchEvent';

export { default as Pixel } from '../Pixel';
export { maybeHandle } from '../maybeHandle';
export { default as connectToOneTrust } from '../oneTrust/connectToOneTrust';
export { default as createPixelComponent } from '../createPixelComponent';

export { STRICTLY_NECESSARY, FUNCTIONAL, TARGETING, ADVERTISING } from '../constants';

categories.addChangeListener((allowedCategories) => {
	dispatchEvent('categoriesUpdated', {categories: allowedCategories});
});

categories.addChangeListener((allowedCategories) => {
	queue.drain(allowedCategories);
});

function getCookieCategories() {
	if (!window.utag) return [];

	const values = {},
		rcd = (function() {
			let value = "; " + document.cookie;
			let parts = value.split("; CONSENTMGR=");
			if (parts.length == 2)
				return window.utag.ut.decode(parts.pop().split(";").shift());
		}()),
		cd = window.utag.gdpr.typeOf(rcd) === "string" ? rcd : "";
	if (window.utag.data) {
		window.utag.data["cp.CONSENTMGR"] = cd;
	}
	if (cd) {
		let i, optOut, optOutData = decodeURI(cd).split("|");
		for (i = 0; i < optOutData.length; i++) {
			optOut = optOutData[i].split(":");
			values[optOut[0]] = optOut[1];
		}
	}
	window.utag.gdpr.values = values;
	return Object.keys(values).reduce((acc, c) => {
		if(values[c] === '1' && ['c1','c2','c3','c4'].indexOf(c) > -1) {
			acc.push(c);
		}
		return acc;
	},[]);
}

if (typeof window !== 'undefined') {
	const useTealium = accessNested(window, '__INITIAL_STATE__.appData.options.enableTealiumCookieConsent', false);
	let isTealiumInitialized = false;

	if(useTealium) {
		if (!isTealiumInitialized) {
			const activeGroups = getCookieCategories();
			tealiumCategories.set(activeGroups);

			window.addEventListener('consentdecided', () => {
				const activeGroups = getCookieCategories();
				return tealiumCategories.set(activeGroups);
			});

			isTealiumInitialized = true;
		}
	}
}
